module.exports = __webpack_public_path__ + "static/media/tesla-insurance.3116b0d4.svg";